import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import { changePassword } from "../../services/Management/UserProfileService";

import { signoutUser } from "../../actions/UserActions";

import PasswordValidationRulesBuilder from "../../constants/PasswordValidationRulesBuilder";

import PasswordRequirements from "../ProfileSidebar/_PasswordRequirements";

import defaultBg from "../../assets/backgrounds/bloom.jpg";
import defaultLogo from "../../assets/logos/Logo-Oasis.svg";
import Paths from "../../constants/Paths";

class ResetPassword extends Component {
  state = {
    fieldValues: {
      email: this.props.User["user-email"] || "",
      oldPassword: "",
      newPassword: "",
      confirmNewPassword: "",
    },
    background: defaultBg,
    done: false,
    passwordPoliciesLoaded: false,
  };
  handleChange = (field, value) => {
    this.setState({
      fieldValues: {
        ...this.state.fieldValues,
        [field]: value,
      },
    });
  };
  componentDidMount() {
    const { User, history } = this.props;

    if (!User || !User["user-email"]) {
      history.push(Paths.Login);
    }

    PasswordValidationRulesBuilder.setPasswordPolicies().then((response) => {
      PasswordValidationRulesBuilder.passwordPolicies = response;
      this.setState({ passwordPoliciesLoaded: true });
    });
  }

  render() {
    const { _, signoutUser, User, history, logo } = this.props;
    const { done, fieldValues, passwordPoliciesLoaded } = this.state;

    if (passwordPoliciesLoaded) {
      PasswordValidationRulesBuilder.setValidationRules(
        { ...fieldValues },
        User.userStatus,
        _
      );
    }

    return (
      <div className="login-screen forgot-password reset-password">
        <div className="login-screen-form-wrapper">
          {done ? (
            <div className="reset-password-complete">
              <img
                src={logo || defaultLogo}
                alt={_.Logo}
                className="login-screen-logo"
              />
              <i className="icon-omni-tick-circle" />
              <h3>Password Changed</h3>
              <p>
                <span>
                  <a href="/login">Continue to Login</a>
                </span>
              </p>
              <p className="login-screen-footer-copyright">
                {_.FooterCopyright}
              </p>
            </div>
          ) : (
            <div className="container-fluid">
              <div className="row">
                <div className="login-password-requirements col-md-5 px-3 py-2">
                  <div className="login-password-requirements-flex-container d-flex flex-column justify-center">
                    <img
                      src={defaultLogo}
                      alt={_.Logo}
                      className="login-screen-logo px-3 py-3"
                    />
                    <h4 className="w-100 text-center">{_.PasswordInclude}</h4>
                    <div className="d-flex flex-row">
                      <div className="flex-spacer flex-grow-1"></div>
                      <PasswordRequirements
                        passwordValidationRules={
                          PasswordValidationRulesBuilder.validationRules
                        }
                      />
                    </div>
                    <p className="login-screen-footer-copyright">
                      {_.FooterCopyright}
                    </p>
                  </div>
                </div>
                <div className="col-md-7 p-0">
                  <h3>{_.PasswordReset}</h3>
                  <form className="login-screen-form">
                    {User && User.invalidLogin ? (
                      <div className="alert alert-danger"></div>
                    ) : null}
                    <div className="form-group">
                      <label htmlFor="email">{_.EmailAddress} *</label>
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <div className="input-group-text omni-bgc-mine-shaft-5">
                            <i className="icon-omni-email" />
                          </div>
                        </div>
                        <input
                          type="email"
                          className="form-control"
                          id="email"
                          placeholder={"Enter " + _.EmailAddress}
                          value={fieldValues.email}
                          onChange={(e) =>
                            this.handleChange("email", e.target.value)
                          }
                          disabled={true}
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label htmlFor="password">{_.EnterTemporaryPassword} *</label>
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <div className="input-group-text">
                            <i className="icon-omni-lock" />
                          </div>
                        </div>
                        <input
                          type="password"
                          className="form-control"
                          id="oldPassword"
                          placeholder={_.EnterTemporaryPassword}
                          value={fieldValues.oldPassword}
                          autoComplete="new-password"
                          onChange={(e) =>
                            this.handleChange("oldPassword", e.target.value)
                          }
                          required={true}
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label htmlFor="password">{_.EnterNewPassword} *</label>
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <div className="input-group-text">
                            <i className="icon-omni-lock" />
                          </div>
                        </div>
                        <input
                          type="password"
                          className="form-control"
                          id="newPassword"
                          placeholder={_.EnterNewPassword}
                          value={fieldValues.newPassword}
                          onChange={(e) =>
                            this.handleChange("newPassword", e.target.value)
                          }
                          required={true}
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label htmlFor="password">{_.ConfirmNewPassword} *</label>
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <div className="input-group-text">
                            <i className="icon-omni-lock" />
                          </div>
                        </div>
                        <input
                          type="password"
                          className="form-control"
                          id="confirmNewPassword"
                          placeholder={_.ConfirmNewPassword}
                          value={fieldValues.confirmNewPassword}
                          onChange={(e) =>
                            this.handleChange(
                              "confirmNewPassword",
                              e.target.value
                            )
                          }
                          required={true}
                        />
                      </div>
                    </div>
                    <button
                      type="submit"
                      className="btn btn-themed form-control"
                      disabled={
                        !PasswordValidationRulesBuilder.validationRules
                          .map((r) => r.validation)
                          .reduce((a, c) => a && c, true)
                      }
                      onClick={(e) => {
                        e.preventDefault();
                        const { oldPassword, newPassword } = fieldValues;
                        changePassword({ oldPassword, newPassword }).then(
                          () => {
                            signoutUser();
                            this.setState({
                              done: true,
                            });
                          }
                        );
                      }}
                    >
                      {_.Confirm}
                    </button>
                  </form>
                  <p className="login-screen-or">{_.Or}</p>
                  <p className="cancel-link">
                    <Link
                      to={Paths.Login}
                      onClick={(e) => {
                        e.preventDefault();
                        signoutUser().then(() => {
                          history.push(Paths.Login);
                        });
                      }}
                    >
                      {_.CancelReset}
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => state;
const mapActionsToProps = {
  signoutUser,
};
export default connect(mapStateToProps, mapActionsToProps)(ResetPassword);
